import { jsx as _jsx } from "react/jsx-runtime";
export const MenuList = props => (_jsx("div", { className: "relative py-1 rounded-md shadow-lg bg-surface border border-line-subdued overflow-auto", style: { maxHeight: '236px' }, ...props }, void 0));
//# sourceMappingURL=MenuList.js.map